import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useIncomeActions() {
  const [isLoading, setLoading] = useState(false);

  const remove = useCallback((incomeId) => {
    setLoading(true);
    return quarkusApi
      .delete(`/financial/incomes/${incomeId}`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const receive = useCallback((incomeId, incomeToReceive) => {
    setLoading(true);
    return quarkusApi
      .post(`/financial/incomes/${incomeId}/receive`, incomeToReceive, authHeader())
      .finally(() => setLoading(false));
  }, []);

  return { remove, receive, isLoading };
}
